import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Users, UserCheck, CreditCard, Mail, Sparkles } from "lucide-react";
import { formatAiCredits } from "@/lib/formatAiCredits";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const KpiCard = ({ label, value, icon: Icon }) => (
  <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="text-xs uppercase tracking-wide text-[#9CA3AF]">{label}</p>
        <p className="mt-2 text-2xl font-heading font-semibold text-[#F3F4F6]">{value}</p>
      </div>
      <div className="p-2 rounded-lg bg-[#00D1FF]/10 text-[#00D1FF]">
        <Icon className="w-5 h-5" />
      </div>
    </div>
  </div>
);

const AdminOverview = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${BACKEND_URL}/api/admin/overview`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(res.data);
      } catch (err) {
        setError(err.response?.data?.detail || "Failed to load overview");
      }
    };
    load();
  }, []);

  if (error) {
    return <p className="text-red-400">{error}</p>;
  }

  if (!data) {
    return <p className="text-[#9CA3AF]">Loading overview…</p>;
  }

  return (
    <div data-testid="admin-overview">
      <h1 className="font-heading text-2xl font-bold mb-2">Overview</h1>
      <p className="text-[#9CA3AF] text-sm mb-8">Platform metrics at a glance</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <KpiCard label="Total users" value={data.total_users} icon={Users} />
        <KpiCard label="Clients" value={data.total_clients} icon={UserCheck} />
        <KpiCard label="Partners" value={data.total_partners} icon={Users} />
        <KpiCard label="Admins" value={data.total_admins} icon={Sparkles} />
        <KpiCard label="Active subscriptions" value={data.active_subscriptions} icon={CreditCard} />
        <KpiCard
          label="Credits used (all users)"
          value={formatAiCredits(data.total_credits_used)}
          icon={CreditCard}
        />
        <KpiCard label="Lead inquiries (7d)" value={data.lead_inquiries_7d} icon={Mail} />
      </div>
    </div>
  );
};

export default AdminOverview;
